const previous_projectid = payload => {
  return {
    type: "preprojectid",
    payload
  };
};

export default previous_projectid;
